import React from "react";
import profile from "../../../assets/images/CompanyLogo/profile.webp";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import TorchEffect from "../../torchEffect/TorchEffect";

const CreateProfile = () => {
  const { isLoggedIn } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const handleNavigate = () => {
    navigate("/sign-up");
  };

  return (
    <>
      {isLoggedIn ? (
        <div className="my-20"></div>
      ) : (
        // <TorchEffect style={{ backgroundColor: "rgba(0,0,0,0.4)", width: "100%" }} autoHeight={true}>
          <div
            className="max-w-[1200px] ml-4 mr-4 md:mx-auto text-f10 rounded-xl flex relative"
          // style={{
          //   backgroundImage: `url(${profile})`,
          //   backgroundRepeat: "no-repeat",
          //   backgroundPosition: "center",
          //   backgroundSize: "cover",
          // }}
          >
            <div className="max-w-[100%] text-left border-0 mx-auto sm:p-8 md:p-16">
              <div className="frame w-auto bg-center rounded-8 justify-between p-4">
                <div className=" flex-col sm:flex md:flex-row ">
                  <div className="w-auto flex flex-col items-center justify-center relative gap-[2rem]">
                    <p className="text-left text-white font-bold sm:text-f32 md:text-[4rem] leading-7 text-f24 text-center">
                      Create Your Company Profile Now
                    </p>
                    <p className="max-w-[37.75rem] m-auto leading-6 sm:mt-4 mt-2 text-center text-white font-normal justify-start text-f14 sm:text-f18 md:text-[1.25rem] wrap">
                      Begin your journey with us today by creating your own
                      company profile and become a valued member of our trusted
                      company community!
                    </p>
                    <button onClick={handleNavigate} className="w-[150px] h-[42px] md:w-[200px] mt-3 mb-3 md:h-[48px] text-f14 sm:text-f16 text-link bg-white hover:bg-primary-400 font-semibold rounded md:block shadow-[0_-2px_0_#bc3214] transform transition-all duration-300 hover:shadow-[0_0_0_#0000] hover:-translate-y-[2px] mt-[1rem]">
                      Create Profile
                    </button>
                  </div>
                  {/* <div className="flex flex-col sm:flex-row items-center"> */}
                  {/* <button onClick={handleNavigate} className="w-[150px] h-[42px] md:w-[200px] mt-3 mb-3 md:h-[60px] text-f14 sm:text-f16 text-white bg-primary hover:bg-primary-400 font-semibold rounded md:block shadow-[0_-2px_0_#bc3214] transform transition-all duration-300 hover:shadow-[0_0_0_#0000] hover:-translate-y-[2px]">
                      Create Profile
                    </button> */}
                  {/* <div
                    className="text-white text-f14 sm:text-f16 mx-auto font-semibold cursor-pointer"
                    onClick={handleNavigate}
                  >
                    Create Profile
                  </div> */}
                  {/* </div> */}
                </div>
              </div>
            </div>
          </div>
        // </TorchEffect>
      )}
    </>
  );
};

export default CreateProfile;
